import React, { useState } from 'react';
import { ShadedBox } from '../Common/ShadedBox';
import { Subtitle } from '../Common/Subtitle';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { useHistory } from 'react-router';
import { billingRoutes } from '../..';
import { Service } from '~/types/models';
import LegacyChangePlanModal from '~/App/Modules/Billing/Components/LegacyChangePlanModal';
import useCurrentTeam from '~/react-hooks/use-current-team';

export type ChangePlanPanelProps = {
  service?: Service;
};

export function ChangePlanPanel({ service }: ChangePlanPanelProps) {
  const history = useHistory();
  const [showChangeLegacyPlanModal, setShowChangeLegacyPlanModal] =
    useState(false);
  const { on_legacy_plan: onLegacyPlan } = useCurrentTeam();

  const onChangePlanClicked = () => {
    if (onLegacyPlan) {
      setShowChangeLegacyPlanModal(true);
    } else {
      history.push(`${billingRoutes.pricing}/${service ?? ''}`);
    }
  };

  return (
    <ShadedBox className='block h-full'>
      <div className='flex flex-col gap-y-4 items-center text-center lg:items-start xmd:text-left'>
        <Subtitle label='Not happy with your plan?' />
        <span className='text-base leading-relaxed v2-text-neutral-900'>
          Need more inclusions? Try a different plan.
        </span>
        <Button
          variant={ButtonVariant.Primary}
          className='py-2 w-full lg:w-auto w-max'
          onClick={onChangePlanClicked}
        >
          Change plan
        </Button>
      </div>
      <LegacyChangePlanModal
        open={showChangeLegacyPlanModal}
        onModalClose={() => setShowChangeLegacyPlanModal(false)}
      />
    </ShadedBox>
  );
}
